// extracted by mini-css-extract-plugin
module.exports = {"main":"dhsg-XZw4-main"};